export enum ComponentTypeEnum {
  ACTIVITIES = 'generic.activities',
  BANNER = 'generic.banner',
  DIVIDER = 'generic.divider',
  WIDGET = 'generic.external-widget',
  WYSIWYG = 'generic.wysiwyg',
  SEARCH = 'configuration.search',
  CARDS = 'generic.card-collection',
  IMAGE = 'generic.responsive-image',
  ADVICE = 'generic.advice',
  OFFER = 'generic.offer-page',
  PICTURE_AND_TEXT = 'generic.picture-and-text',
  TEXT_AND_BLOCK = 'generic.text-and-blocks',
  PIPEDRIVE_WEBFORM = 'generic.pipedrive-webform',
}
